const WebsocketReducer = (state = {}, action) => {
  switch (action.type) {
    case 'WS_EVENT':
      return action.data;
    default:
      return state;
  }
};

export {WebsocketReducer};
